import useUserBookStatus from "hooks/fragments/userUserBookStatus";
import { slugIdConstants } from "types/UserBookStatusType";

import BookMatchPercentageForUser from "./BookMatchPercentageForUser";

export interface Props {
  bookId: number;
  size?: "sm" | "md" | "lg";
}

export default function BookMatchPercentage({ bookId, size = "sm" }: Props) {
  const { userId, statusId } = useUserBookStatus(bookId);
  // Don't show match percentage if:
  //   Not logged in
  //   Already read
  if (!userId || statusId === slugIdConstants.read) {
    return <></>;
  }
  return <BookMatchPercentageForUser bookId={bookId} size={size} />;
}
